export interface IMetadata {
  brand: string;
  contractUid: string;
  hcid: string;
  mbrUid: string;
  userName: string;
  firstName: string;
  lastName: string;
  mbrSequenceNbr: string;
  dob: string;
  groupId: string;
  isCastlightTransparency: boolean;
  sourceSystem: string;
  alphaPrefix: string;
  webGuid: string;
  isEmulateFlag: boolean;
  isSecureState: boolean;
  dplUrl: string;
  identificationNumber: string;
  idToken: string;
  pcpIndicator: string;
  isWebView: boolean;
  isChangePCP: boolean;
  isCareTeam: boolean;
  mobileOS: string;
  metaSrcEnv: string;
  addresses: Array<IAddresses>;
  personalizedSessionId?: string;
  locale?: string;
  acstkn?: string; // clientjwt access token
  lob?: string;
  isMemberSession?: boolean;
}

export interface IAddresses {
  type: string;
  addressLineOne: string;
  addressLineTwo?: string;
  city: string;
  state: string;
  postalCode: string;
}

export interface IPCP {
  [key: string]: IMemberPCP;
}
export interface IMemberPCP {
  currentPCP: string;
  futurePCP: string;
}

export interface IPublicMetadataRequest {
  brand?: string;
  envCode?: string;
  lob?: MbrLob;
  fcinitiator?: string;
  locale?: string;
  queryParams?: object;
}

export interface ISecureMetadataRequest extends IPublicMetadataRequest {
  userNm?: string;
  memberUid?: string;
  contractUid?: string;
  authToken?: string;
  emulationInd?: boolean;
  isWebView?: boolean;
  mobileOS?: string;
  personalizedSessionId?: string;
  cacheKey?: string;
  customFeatures?: string[];
}

export interface IMetadataResponse {
  fcLoader: string;
  metadata: string;
}

export interface IMetaHeaders {
  metaSenderApp?: string;
  metaClientApp?: string;
  metaConsumerApp?: string;
}

export enum MbrLob {
  COMMERCIAL = 'COMMERCIAL',
  MEDICAID = 'MEDICAID',
  MEDICARE = 'MEDICARE'
}
export interface IMetadataRequestSchema {
  field: string;
  required?: boolean;
  type: string;
  description?: string;
  default?: string;
  example?: string | boolean | string[];
  valueType?: string;
  values?: string[];
  properties?: IMetadataRequestQueryParamSchema[];
}

export interface IMetadataRequestQueryParamSchema {
  field: string;
  type: string;
  description?: string;
  default?: string;
  example?: string | boolean;
  valueType?: string;
  values?: string[];
}
